/*
 * @description:
 * @author: Jason Wong
 * @since: 2019-08-19 13:09:08
 */

import Axios from "axios";
import { get } from "./base";
import { initDictOptions } from '@/utils/dict/index.js';

/**
 * get configure value associated with {key}
 * @param {String} key
 * @returns {String}
 */
function getConfigureValue(key) {
  return Axios.get(`/configure/${key}`);
}

/**
 * configration entity
 */
class ConfigureEntity {
  key;
  configure;

  constructor(key, configure) {
    this.key = key;
    this.configure = configure;
  }
}

/**
 * save configuration
 * @param {ConfigureEntity} configureObject
 */
function saveConfigure(configureObject) {
  return Axios.post(`/configure/save`, configureObject);
}

export { getConfigureValue, ConfigureEntity, saveConfigure };

/**
 * get uri of websocket
 * @param {String} key
 */
const WEBSOCKET_URI_KEY = "websocketUrl";
function getWebsocketUrl() {
  return getConfigureValue(WEBSOCKET_URI_KEY);
}

/**
 * save websocket info
 * @param {String} value
 */
function setWebsocketUrl(value) {
  return saveConfigure(new ConfigureEntity(WEBSOCKET_URI_KEY, value));
}

/**
 * get version
 */
function getVersion() {
  return get("/configure/version");
}

function getSysUsedFileSize() {
  return get("/configure/fileSize/used");
}
function getLimitFileSize() {
  return get("/configure/fileSize/limit");
}
function refreshUsedFileSize() {
  return get("/configure/fileSize/refresh");
}

export { getWebsocketUrl, setWebsocketUrl, getVersion,getSysUsedFileSize,getLimitFileSize,refreshUsedFileSize };

const MAIL_URI_KEY = "mailWebsocket";
async function getMailURI() {
  const uriRes = await getConfigureValue(MAIL_URI_KEY);
  if (!uriRes.data.success) throw uriRes.data.error;
  return uriRes.data.data;
}
export { getMailURI };

/**
 * Get langauge list
 * @returns {Array<{name:String,code:String}>}
 */
export async function getLangauges(){
  let dictOptions = await initDictOptions("language");
  if(dictOptions && dictOptions.length >0 ){
    await dictOptions.forEach((dict) => {
      dict.code=dict.value;
      dict.name=dict.text;
    });
  }
  return dictOptions;
}